module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Patrick Delaforce\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Patrick Delaforce served with 11th Armoured Division during the advance through NW Europe."), _c('BR'), _c('BR'), _vm._v("After a career in the wine trade he became a professional writer. Among his books in print with Pen & Sword are Churchills Desert Rats in North Africa, Burma, Sicily and Italy, Wellington Le Beau and Montys Marauders.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BbtJ9g/tc-custom/9781473834828.jpg?1705026307213",
      "alt": "This image is the cover for the book Marching to the Sound of Gunfire"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Marching to the Sound of Gunfire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this exciting and revealing book, scores of British soldiers tell their amazing stories of life  and death  in the front line of the Allies' advance from Normandy to Hitler's Germany. In eleven months of bitter fighting between D-Day and VE Day the combined efforts of the British and their allies' armed forces ground down their ruthless enemy in the pursuit of victory. Each and every man has a unique story to tell, whether they were infantry, tank crews, gunners, sappers or in vital logistic and supporting units. Theirexperiences make for powerful and fascinating reading. First-hand accounts of the landings, liberation of towns and villages, fierce actions, not all successful, bring home to the reader the cost of war as well as the magnitude of the venture. Particularly evocative is the range of emotions that were experienced by those involved, be they generals or the most junior soldiers. The passage of time means that many of these 'voices' will be heard no more but fortunately Marching to the Sound of Gunfire captures their inspiring testimonies for posterity.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0